import { AbstractControl, FormGroup } from '@angular/forms';
import { OfferVariantGroup } from '../models/offer';

export function OfferPhotoValidator(control: AbstractControl) {
    const formGroup = control as FormGroup;
    const medias = formGroup.get('medias').value;
    const offerVariantGroupMedias: OfferVariantGroup[] = formGroup.get('offerVariantGroupsMedias').value;

    if ((!medias || medias?.length === 0) && !offerVariantGroupMedias && offerVariantGroupMedias?.length === 0) {
        return { noPhoto: true };
    }

    // When we have offer variant group medias check that all items have at least one entry
    if (offerVariantGroupMedias?.length > 0) {
        for (const offerVariantGroupMedia of offerVariantGroupMedias) {
            if (offerVariantGroupMedia.medias.length < 2) {
                return { noPhoto: true };
            }
        }

        return null;
    }

    if (medias?.length < 2) {
        return { noPhoto: true };
    }

    return null;
}
